import { render, staticRenderFns } from "./index.vue?vue&type=template&id=84a479ca&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=84a479ca&prod&scoped=true&lang=css"
import style1 from "./index.vue?vue&type=style&index=1&id=84a479ca&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84a479ca",
  null
  
)

export default component.exports